import Body from "../../../../../../material/skeleton/Body";
import Footer from "../../../../../../material/skeleton/Footer";
import Box from "@mui/material/Box";
import {Button} from "@mui/material";
import {useEffect, useRef, useState} from "react";
import {ArrowDownward, CheckCircle, NavigateNext} from "@mui/icons-material";
import useQualityInspectionRepository from "../../../../../../repository/emergency/useQualityInspectionRepository";
import QualityInspection from "../../../../../../entity/emergency/QualityInspection";
import NotifyWork from "./NotifyWork";
import PopperWrapper from "../../../../../../material/popper/PopperWrapper";
import parameter from "../../../../../../enum/parameter";
import useEventDispatcher from "../../../../../../use/useEventDispatcher";
import ReportStepIdentifyIssue from "./report-step/ReportStepIdentifyIssue";
import ReportStepIsIssueSolved from "./report-step/ReportStepIsIssueSolved";
import useQuotationRepository from "../../../../../../repository/emergency/useQuotationRepository";
import useQuotationItemRepository from "../../../../../../repository/emergency/useQuotationItemRepository";
import useInterventionRepository from "../../../../../../repository/emergency/useInterventionRepository";
import ReportStepAdditionalShifting from "./report-step/ReportStepAdditionalShifting";
import ReportStepAdditionalMainWork from "./report-step/ReportStepAdditionalMainWork";
import ReportStepActionTakenToSolveIssue from "./report-step/ReportStepActionTakenToSolveIssue";
import ReportStepDifficulty from "./report-step/ReportStepDifficulty";
import isNull from "../../../../../../mixin/isNull";
import {useParams} from "react-router";


export default function ({qualityInspectionId, clientId, interventionId, orderId}) {
    const {token} = useParams();
    const eventDispatcher = useEventDispatcher();
    const interventionRepository = useInterventionRepository();
    const qualityInspectionRepository = useQualityInspectionRepository();
    const quotationRepository = useQuotationRepository();
    const quotationItemRepository = useQuotationItemRepository();
    const [loading, setLoading] = useState(false);
    const [reportStep, setReportStep] = useState(0);
    const nextStepButtonRef = useRef();
    const reportResult = useRef({});
    const numberOfAdditionalShifting = useRef(0);
    const containsAdditionalMainWork = useRef(false);

    useEffect(() => {
        eventDispatcher.launcher("completed-works");
    }, []);

    useEffect(() => {
        if (reportStep !== 7) return;

        nextStep();
    }, [reportStep]);

    const nextStep = async () => {
        setLoading(true);
        let comment = `Problème identifié : ${reportResult.current[1].identified_issue}.`;

        if (reportResult.current[2].is_solved === false) {
            comment += `\nLe problème n'est pas résolu : ${reportResult.current[2].why}`;
        } else {
            if (!isNull(reportResult.current[3])) {
                comment += "\nJustification des déplacements supplémentaires :";

                Object.keys(reportResult.current[3]).forEach((key) => {
                    comment += `\nDéplacement supplémentaire ${key} : ${reportResult.current[3][key]}.`;
                });
            }

            if (!isNull(reportResult.current[4])) {
                comment += `\nJustification de la main d'oeuvre supplémentaire : ${reportResult.current[4].justification}.`;
            }

            comment += "\nDétail des actions menées par l'IR pour résoudre le problème :";

            Object.keys(reportResult.current[5]).forEach((key) => {
                comment += `\nAction menée ${key} : ${reportResult.current[5][key]}.`;
            });

            comment += `\nDifficultés rencontrées par l'IR : ${reportResult.current[6].difficulty}.`;
        }


        const res = await qualityInspectionRepository.update(qualityInspectionId, "current_step", {
            quality_inspection: {
                current_step: QualityInspection.STEP_WORK,
                completed_works: comment
            }
        });

        if (!res) setLoading(false);
    }

    const nextReportStep = async data => {
        if (reportStep === 0 && token === "demo") {
            reportResult.current = {
                1: {
                    identified_issue: "Demo application"
                },
                2: {
                    is_solved: false,
                    why: "Démo application"
                }
            }
            nextStep();
            return;
        }

        if (reportStep > 0) {
            reportResult.current[reportStep] = data;
        }

        if (reportStep === 2) {
            if (data.is_solved === false) {
                setReportStep(7);
                return;
            }

            /** @type Intervention */
            const intervention = await interventionRepository.findOneById(interventionId).exec();
            /** @type Quotation */
            const quotation = await quotationRepository.findOneById(intervention.getQuotationId()).exec();
            /** @type QuotationItem[] */
            const quotationItems = await quotationItemRepository.findAllByQuotationId(quotation.getId()).exec();

            quotationItems.forEach(quotationItem => {
                if (quotationItem.getName() === parameter.ADDITIONAL_SHIFTING_NAME) {
                    numberOfAdditionalShifting.current = quotationItem.getQuantity();
                }

                if (quotationItem.getName() === parameter.ADDITIONAL_MAIN_WORK_NAME) {
                    containsAdditionalMainWork.current = true;
                }
            });

            if (numberOfAdditionalShifting.current > 0) {
                setReportStep(3);
                return;
            }

            if (containsAdditionalMainWork.current) {
                setReportStep(4);
                return;
            }

            setReportStep(5);
            return;
        }

        if (reportStep === 3) {
            if (containsAdditionalMainWork.current) {
                setReportStep(4);
                return;
            }

            setReportStep(5);
            return;
        }

        setReportStep(reportStep + 1);
    }

    if (reportStep === 0) {
        return (
            <>
                <Body>
                    <Box mt={2}>
                        <NotifyWork/>
                    </Box>
                </Body>
                <Footer>
                    <Button
                        sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                        startIcon={<NavigateNext/>}
                        variant="contained"
                        fullWidth
                        size={"large"}
                        onClick={nextReportStep}
                        ref={nextStepButtonRef}
                        data-test="button-next-step"
                    >
                        Compléter le compte rendu
                    </Button>
                </Footer>
            </>
        );
    }

    if (reportStep === 1) return <ReportStepIdentifyIssue next={nextReportStep}/>;

    if (reportStep === 2) return <ReportStepIsIssueSolved next={nextReportStep}/>;

    if (reportStep === 3) return <ReportStepAdditionalShifting
        next={nextReportStep}
        additionalShiftingQuantity={numberOfAdditionalShifting.current}
    />;

    if (reportStep === 4) return <ReportStepAdditionalMainWork next={nextReportStep}/>;

    if (reportStep === 5) return <ReportStepActionTakenToSolveIssue next={nextReportStep}/>;

    if (reportStep === 6) return <ReportStepDifficulty next={nextReportStep}/>;


    return (
        <>
            <Body>

            </Body>
            <Footer>
                <PopperWrapper
                    elementRef={nextStepButtonRef}
                    placement={"top"}
                    content={"Vous pouvez passer à l'étape suivante"}
                    triggeringEvent={"next-step-available"}
                    autoCloseAfter={parameter.POPUP_TIME}
                    displayCloseButton={false}
                    contentColor={parameter.POPUP_COLOR}
                    icon={<ArrowDownward color={parameter.POPUP_COLOR}/>}
                />
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    variant="contained"
                    fullWidth
                    size={"large"}
                    onClick={nextStep}
                    disabled={loading}
                    ref={nextStepButtonRef}
                    data-test="button-next-step"
                >
                    Envoie du CR
                </Button>
            </Footer>
        </>
    )
}